type Translator = (key: string) => string

let translator: Translator | null = null

export function setTranslator(fn: Translator | null): void {
  translator = fn
}

export function translate(key: string): string {
  if (!key) return key
  return translator ? translator(key) : key
}
